import NetworkCheckIcon from '@material-ui/icons/NetworkCheck'
import List from './List'

export default {
  list: List,
  icon: NetworkCheckIcon,
}
